import { Alert, Button, Card, FieldBlock, Input } from '@orbind/ui'
import { useState, type FormEvent } from 'react'
import { api } from '../lib/api.ts'
import { OrbindLogo } from '../shell/OrbindLogo.tsx'
import './login.css'

/**
 * Pede o link de redefinição de senha por e-mail.
 *
 * A resposta da API é sempre a mesma, exista ou não a conta — a tela por
 * design não pode diferenciar os dois casos, senão a UI vira o jeito de
 * descobrir quais e-mails têm cadastro.
 */
export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [enviado, setEnviado] = useState(false)
  const [erro, setErro] = useState<string | null>(null)

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setEnviando(true)
    setErro(null)
    try {
      await api.auth['forgot-password'].$post({ json: { email } })
      setEnviado(true)
    } catch {
      setErro('Não foi possível processar o pedido agora. Tente novamente em instantes.')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="ob-root login">
      <section className="login__brand" aria-hidden>
        <div className="login__logo">
          <OrbindLogo size={44} color="#FFFFFF" halo="var(--ob-primary)" />
        </div>
        <h1 className="login__brand-title">Orbind</h1>
        <p className="login__brand-text">Redefina sua senha em poucos passos.</p>
      </section>

      <section className="login__panel">
        <Card className="login__card">
          {enviado ? (
            <>
              <h2 className="login__title">Verifique seu e-mail</h2>
              <p className="login__subtitle">
                Se <strong>{email}</strong> tiver uma conta no Orbind, enviamos um link para redefinir a senha. Ele
                vale por 1 hora.
              </p>
              <Button variant="ghost" onClick={() => (window.location.href = '/login')}>
                Voltar ao login
              </Button>
            </>
          ) : (
            <>
              <h2 className="login__title">Esqueci minha senha</h2>
              <p className="login__subtitle">Informe seu e-mail e enviamos um link para você escolher uma nova.</p>

              <form className="ob-stack" onSubmit={onSubmit} noValidate>
                {erro ? (
                  <Alert tone="danger" title="Algo deu errado">
                    {erro}
                  </Alert>
                ) : null}

                <FieldBlock label="E-mail" required>
                  {({ id }) => (
                    <Input
                      id={id}
                      type="email"
                      autoComplete="email"
                      autoFocus
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="voce@empresa.com.br"
                    />
                  )}
                </FieldBlock>

                <Button type="submit" variant="primary" loading={enviando}>
                  Enviar link
                </Button>

                <a href="/login" className="login__link" style={{ textAlign: 'center' }}>
                  Voltar ao login
                </a>
              </form>
            </>
          )}
        </Card>
      </section>
    </div>
  )
}
